import {IonicConfig} from '@ionic/core';
import {Animation, createAnimation, iosTransitionAnimation} from '@ionic/angular/standalone';

export const ionicConfig: IonicConfig = {
  mode: 'ios',
  scrollAssist: false,
  scrollPadding: false,
  navAnimation: (baseEl: any, opts?: any): Animation => {
    const enteringEl: HTMLElement = opts.enteringEl;
    const leavingEl: HTMLElement = opts.leavingEl;

    const animation: Animation = iosTransitionAnimation(baseEl, opts);

    if (animation) {
      if (enteringEl) {
        const toolbarEnteringAnimation: Animation = createAnimation()
        .addElement(enteringEl.querySelector(':scope ion-toolbar'))
        .fromTo('opacity', '0', '1');

        animation.addAnimation(toolbarEnteringAnimation);
      }

      if (leavingEl) {
        const toolbarLeavingAnimation: Animation = createAnimation()
        .addElement(leavingEl.querySelector(':scope ion-toolbar'))
        .fromTo('opacity', '1', '0');

        animation.addAnimation(toolbarLeavingAnimation);
      }
    }

    return animation;
  }
};
